
  <template>
  <el-dialog
    class="ts-modal ts-modal--sga no-padding"
    :before-close="closeModal"
    :visible.sync="showModal"
    width="740px"
    title="Role Info"
  >
    <div class="ts-modal--sga-header role-header">
      <h6>{{ this.role.Position }}</h6>
      <div style="margin-top:10px" v-if="this.role.fullSga.sgaEmployeeInfo.expirationDate != null">
        <span><b>Expiration Date: </b> {{ this.role.fullSga.sgaEmployeeInfo.expirationDate | moment("MMM Do YYYY") }}</span>
      </div>
    </div>
    
    <div style="margin-top:30px !important" class="ts-modal--tabs">
      <el-tabs v-model="activeTab" type="card">

        <el-tab-pane name="upskilling" v-if="this.role.fullSga.sgaUpSkills">
					<span slot="label"><i class="el-icon-star-on"></i> Upskilling</span>
          <span class="h6">Upskilling Required</span>
					<div class="sga-split">
						<div class="sga-items" v-if="this.role.fullSga.sgaUpSkills.knowledgeRegularlyUsed">
							<div class="sga-items_item heading"><span>Knowledge</span></div>
							<div class="sga-items_item flexed" v-for="(upskill, index) in this.role.fullSga.sgaUpSkills.knowledgeRegularlyUsed" :key="index">
								<img src="~../../../assets/img/upskill3.svg">
								<div class="right">
									<span>{{ upskill.selection }}</span>
								</div>
							</div>
						</div>
						<div class="sga-items" v-if="this.role.fullSga.sgaUpSkills.workingPracticeSkills">
							<div class="sga-items_item heading"><span>Skills</span></div>
							<div class="sga-items_item flexed" v-for="(upskill, index) in this.role.fullSga.sgaUpSkills.workingPracticeSkills" :key="index">
								<img src="~../../../assets/img/upskill3.svg">
								<div class="right">
									<span>{{ upskill.selection }}</span>
								</div>
							</div>
						</div>
					</div>
        </el-tab-pane>

        <el-tab-pane label="Tasks" name="tasks">
          <span class="h6">Tasks</span>
					<div class="sga-items">
						<div class="sga-items_item flexed" v-for="(task, index) in this.role.fullSga.sgaYourJob.jobDescriptionTasks" :key="index">
              <v-icon name="check-circle" />
							<span>{{ task }}</span>
						</div>
					</div>
        </el-tab-pane>

        <el-tab-pane label="Activities" name="activities">
          <span class="h6">Activities</span>
					<div class="sga-items">
						<div class="sga-items_item flexed" v-for="(activity, index) in this.role.fullSga.sgaHiddenExtras.workingPracticeActivities" :key="index">
              <v-icon name="check-circle" />
							<span>{{ activity.selection }}</span>
							<!-- <span>{{ activity.Value }}</span> -->
						</div>
					</div>
        </el-tab-pane>

        <el-tab-pane label="Knowledge" name="knowledge">
          <span class="h6">Knowledge</span>
          <div class="sga-split">
						<div class="sga-items">
							<div class="sga-items_item heading"><span>Expected by employer</span></div>
              
              <div class="sga-items_item" v-for="(knowledge, index) in this.role.fullSga.sgaKnowledge.knowledgeRegularlyUsed" v-if="knowledge.value == 'IN'" :key="index">
								<!-- <img src="~../../../assets/img/inwork.svg" alt="Inside role" /> -->
								<span>{{ knowledge.selection }}</span>
								<span>{{ knowledge.yearsOfExperience }} years experience</span>
							</div>
						</div>
						<div class="sga-items">
							<div class="sga-items_item heading"><span>Employee adds to role</span></div>

              <div class="sga-items_item" v-for="(knowledge, index) in this.role.fullSga.sgaKnowledge.knowledgeRegularlyUsed" v-if="knowledge.value == 'OUT'" :key="index">
								<!-- <img src="~../../../assets/img/outwork.svg" alt="Outside of role" /> -->
                <span>{{ knowledge.selection }}</span>
								<span>{{ knowledge.yearsOfExperience }} years experience</span>
							</div>
						</div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Skills" name="skills">
          <span class="h6">Skills</span>
					<div class="sga-split">
						<div class="sga-items">
							<div class="sga-items_item heading"><span>Expected by employer</span></div>
							<div class="sga-items_item" v-for="(skill, index) in this.role.fullSga.sgaSkills.workingPracticeSkills" :key="index" v-if="skill.value == 'IN'">
                <!-- <img src="~../../../assets/img/inwork.svg" alt="Outside of role" /> -->
								<span>{{ skill.selection }}</span>
								<span>{{ skill.yearsOfExperience }} years experience</span>
							</div>
						</div>
						<div class="sga-items">
							<div class="sga-items_item heading"><span>Employee adds to role</span></div>
							<div class="sga-items_item" v-for="(skill, index) in this.role.fullSga.sgaSkills.workingPracticeSkills" :key="index" v-if="skill.value == 'OUT'">
                <!-- <img src="~../../../assets/img/outwork.svg" alt="Outside of role" /> -->
								<span>{{ skill.selection }}</span>
								<span>{{ skill.YearsOfExperience }} years experience</span>
							</div>
						</div>
					</div>
        </el-tab-pane>

        <el-tab-pane label="Essential Skills" name="mindsets">
         <span class="h6">Essential Skills</span>
					<div class="sga-split">
						<div class="sga-items">
							<div class="sga-items_item heading"><span>Expected by employer</span></div>
							<div class="sga-items_item" v-for="(mindset, index) in this.role.fullSga.sgaMindset.mindsets" :key="index" v-if="mindset.value == 'IN'">
                <!-- <img src="~../../../assets/img/inwork.svg" alt="Outside of role" /> -->
								<span>{{ mindset.selection }}</span>
							</div>
						</div>
						<div class="sga-items">
							<div class="sga-items_item heading"><span>Employee adds to role</span></div>
							<div class="sga-items_item" v-for="(mindset, index) in this.role.fullSga.sgaMindset.mindsets" :key="index" v-if="mindset.value == 'OUT'">
                <!-- <img src="~../../../assets/img/outwork.svg" alt="Outside of role" /> -->
								<span>{{ mindset.selection }}</span>
							</div>
						</div>
					</div>
        </el-tab-pane>

        <el-tab-pane label="Talents" name="talents">
          <span class="h6">Hidden Talents</span>
					
					<div class="sga-items" v-if="this.role.fullSga.sgaHiddenTalents">
						<div class="sga-items_item flexed" v-for="(extra, index) in this.role.fullSga.sgaHiddenTalents.skillsKnowledgeOutsideWork" :key="index">
              <v-icon name="check-circle" />
							{{ extra }}
						</div>
					</div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <span slot="footer" class="ts-modal--footer">
      <el-button type="primary" @click="closeModal()">Close</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  created(){
    this.role = this.$route.params.role;
  },
  props: {
    role: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showModal: true,
      activeTab: 'tasks'
    };
  },
  watch: {
    showModal(v) {
      if (v === false);
      this.$emit('close-modal');
    }
  },
  computed: {
    
  },
  beforeDestroy() {
  },
  mounted() {
  },
  methods: {
    closeModal() {
      this.showModal = false;
      this.$router.push({ name: 'role-matching' });
    }
  }
};
</script>

<style scoped>
.temporary-header{
  background-color: #fff3cd;
}
.jb-tag {
  font-family: "acumin-pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  color:#00C8DC;
}

.role-header{
  display:flex !important; 
  flex-wrap:wrap !important;
}
</style>